import { useState } from 'react'
import { PhoneIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'react-i18next'
import Swal from 'sweetalert2'

import RozmowaService from '@/services/RozmowaService'
import { getOsobaPhoneNumber } from './rozmowaDetailsHelpers'

export default function RozmowaActionsCard({ rozmowa }) {
	const { t } = useTranslation()
	const [calling, setCalling] = useState(false)
	const targetPhone = getOsobaPhoneNumber(rozmowa)
	const rozmowaId = rozmowa?._id || rozmowa?.id
	const canCall = Boolean(rozmowaId && targetPhone)

	const handleCall = async () => {
		if (!canCall || calling) return

		setCalling(true)
		const result = await RozmowaService.dial(rozmowaId, targetPhone)
		setCalling(false)

		if (!result.success) {
			await Swal.fire(
				t('conversations.messages.errorTitle'),
				result.error || t('conversations.details.messages.callFailed'),
				'error'
			)
			return
		}

		await Swal.fire(
			t('notifications.successTitle'),
			t('conversations.details.messages.callStarted'),
			'success'
		)
	}

	return (
		<div className="mb-5 rounded-md border border-slate-200 bg-white shadow-sm">
			<div className="border-b border-slate-300 bg-gray-100 px-6 py-3">
				<h2 className="flex items-center gap-2 text-lg font-semibold text-slate-900">
					<PhoneIcon className="h-5 w-5 text-sky-700" />
					<span>{t('conversations.details.sections.dialer')}</span>
				</h2>
			</div>
			<div className="px-6 py-6">
				<button
					type="button"
					onClick={handleCall}
					disabled={!canCall || calling}
					className={`flex w-full items-center justify-center gap-2 rounded-md px-4 py-3 text-sm font-semibold shadow-sm transition ${
						canCall && !calling
							? 'bg-sky-600 text-white hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2'
							: 'cursor-not-allowed bg-gray-300 text-gray-500'
					}`}>
					<PhoneIcon className="h-5 w-5" />
					<span>{calling ? t('conversations.details.actions.calling') : t('conversations.details.actions.call')}</span>
				</button>
			</div>
		</div>
	)
}
